import React from "react";
import { useSelector } from "react-redux";

import TableHead from "../../../../components/UI/TableUI/TableHead";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { truncateDesc } from "../../../../functions/truncateDesc";
import ComplaintActions from "./ComplaintActions";
import GetCheckCross from "../../../../components/UI/viewDialogs/GetCheckCross";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import { hasAnyRole } from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";
import sortDataByDate from "../../../../functions/sorting/sortDataByDate";

const ComplaintsTable = ({ filterComplaintHeadList, setViewDialogDetails }) => {
  const isSorted = useSelector((state) => state.data.isSorted);
  const complaintsData = useSelector((state) => state.data.data);
  const { checkPermission } = UsePermissionsClaim();
  const permAddVisit = checkPermission("add_visit");
  const hasRole = hasAnyRole(adminRoles);

  let dataList = isSorted
    ? complaintsData
    : sortDataByDate(complaintsData, "createdAt");
  const isDataAvailable = complaintsData.length > 0;

  return (
    <div className={`table-container table-height`}>
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={filterComplaintHeadList} />
          {isDataAvailable ? (
            <>
              {dataList.map((data, index) => {
                return (
                  <tr className="table-row" key={index}>
                    <td className="text-left">
                      <p className="w-[7rem] whitespace-normal">
                        {data.station.name}
                      </p>
                      <p className="text-xs lg:text-sm text-gray-400 font-normal">
                        SITE ID-{data.station.id}
                      </p>
                    </td>
                    <td>{data.fieldTechnician.fullName}</td>
                    {hasRole && <td>{data.supervisor.fullName}</td>}
                    <td>{formatDate(data.createdAt)}</td>
                    <td>{formatDate(data.updatedAt)}</td>
                    <td>{truncateDesc(data.description)}</td>
                    <td>{data.category.name}</td>
                    <td>
                      {" "}
                      <GetCheckCross checkVal={data.visitIdList?.length > 0} />
                    </td>
                    <td>{formatDate(data.last_visit_date)}</td>
                    <td>
                      <button
                        className="tableViewBtn"
                        onClick={() =>
                          setViewDialogDetails({ open: true, data: data })
                        }
                      >
                        View
                      </button>
                    </td>
                    {permAddVisit && (
                      <td>
                        <ComplaintActions
                          siteId={data.station.id}
                          siteName={data.station.name}
                          complaintId={data.id}
                          operator={data.fieldTechnician.fullName}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ComplaintsTable;
